import { render, staticRenderFns } from "./CancelRequests.vue?vue&type=template&id=04b49ee9"
import script from "./CancelRequests.vue?vue&type=script&lang=js"
export * from "./CancelRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports